import React from 'react';
import { initialFormValues, warehouseGroupSchema, type WarehouseGroupFormValues } from '../schemas';
import { AritoIcon, BottomActionBarV2, DialogV2, AritoFormV2 } from '@/components/custom/erp';
import { BasicInfoTab } from './BasicInfoTab';

interface FormDialogProps {
  open: boolean;
  onClose: () => void;
  onSubmit: (data: WarehouseGroupFormValues) => void | Promise<void>;
  formMode: 'add' | 'edit' | 'view';
  initialData?: Partial<WarehouseGroupFormValues>;
  onAddButtonClick?: () => void;
  onEditButtonClick?: () => void;
  onDeleteButtonClick?: () => void;
  onCopyButtonClick?: () => void;
}

/**
 * Form dialog for adding, editing, or viewing a warehouse group
 */
export const FormDialog: React.FC<FormDialogProps> = ({
  open,
  onClose,
  onSubmit,
  formMode,
  initialData,
  onAddButtonClick,
  onEditButtonClick,
  onDeleteButtonClick,
  onCopyButtonClick
}) => {
  return (
    <DialogV2
      open={open}
      onClose={onClose}
      title={
        formMode === 'edit' ? 'Sửa nhóm kho hàng' : formMode === 'view' ? 'Xem nhóm kho hàng' : 'Thêm nhóm kho hàng'
      }
      maxWidth='lg'
      disableBackdropClose={false}
      disableEscapeKeyDown={false}
      titleIcon={<AritoIcon icon={539} />}
    >
      <AritoFormV2
        mode={formMode}
        hasAritoActionBar={false}
        schema={warehouseGroupSchema}
        initialData={initialData || initialFormValues}
        onSubmit={onSubmit}
        className='max-h-[calc(100vh-150px)] w-[800px] min-w-[800px] overflow-y-auto'
        headerFields={<BasicInfoTab formMode={formMode} />}
        bottomBar={
          <BottomActionBarV2
            mode={formMode}
            onAdd={onAddButtonClick}
            onEdit={onEditButtonClick}
            onDelete={onDeleteButtonClick}
            onCopy={onCopyButtonClick}
            onSubmit={() => {}}
            onClose={onClose}
          />
        }
      />
    </DialogV2>
  );
};
